import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ServiceItem from "./ServiceItem";
import styles from "./Services.module.css";
import { StoreService } from "../../services/store-service";

interface ServicesProps {
  searchQuery: string;
}

const Services: React.FC<ServicesProps> = ({ searchQuery }) => {
  const navigate = useNavigate();
  const [services, setServices] = useState<any[]>([]);

  useEffect(() => {
    const storedCategories = StoreService.GetData("categories");
    if (storedCategories) {
      setServices(storedCategories);
    }
  }, []);

  const filteredServices = services.filter((service) =>
    service.name.includes(searchQuery)
  );

  const handleServiceClick = (serviceId: number) => {
    navigate(`/times-page?service=${serviceId}`);
  };

  return (
    <section className={`${styles.servicesSection} ios-services-section`}>

      <div className={styles.servicesHeader}>
        <button
          onClick={() => navigate("/ServiceList")}
          className={styles.viewAllButton}
        >
          مشاهده همه
        </button>
        <h6 className={styles.servicesTitle}>سرویس‌ها</h6>
      </div>

      <div className={styles.customScrollbar}>
        {filteredServices.length <= 5 ? (
          // ✅ فقط یک ردیف
          <div className={styles.row}>
            {filteredServices.map((service) => (
              <ServiceItem
                key={service.id}
                id={service.id}
                name={service.name}
                icon={service.logo}
                onClick={() => handleServiceClick(service.id)}
              />
            ))}
          </div>
        ) : (
          // ✅ دو ردیف مثل قبل
          <div className={styles.column}>
            <div className={styles.row}>
              {filteredServices
                .slice(0, Math.ceil(filteredServices.length / 2))
                .map((service) => (
                  <ServiceItem
                    key={service.id}
                    id={service.id}
                    name={service.name}
                    icon={service.logo}
                    onClick={() => handleServiceClick(service.id)}
                  />
                ))}
            </div>
            <div className={styles.row}>
              {filteredServices
                .slice(Math.ceil(filteredServices.length / 2))
                .map((service) => (
                  <ServiceItem
                    key={service.id}
                    id={service.id}
                    name={service.name}
                    icon={service.logo}
                    onClick={() => handleServiceClick(service.id)}
                  />
                ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Services;
